import { imageInfo, srcSetFor } from '../../utils/images'

/**
 * <picture> with AVIF/WebP srcsets from the image manifest. Falls back to a
 * plain <img> for sources that haven't been run through optimize-images.
 */
const ResponsiveImage = ({
  src,
  alt,
  sizes = '100vw',
  className,
  loading = 'lazy',
  fetchPriority,
  ...rest
}) => {
  const info = imageInfo(src)
  const imgProps = {
    src,
    alt,
    className,
    loading,
    decoding: 'async',
    ...(fetchPriority ? { fetchpriority: fetchPriority } : {}),
    ...(info ? { width: info.width, height: info.height } : {}),
    ...rest,
  }

  if (!info) return <img {...imgProps} />

  return (
    <picture className="contents">
      {info.formats.map((fmt) => (
        <source key={fmt} type={`image/${fmt}`} srcSet={srcSetFor(src, fmt)} sizes={sizes} />
      ))}
      <img {...imgProps} />
    </picture>
  )
}

export default ResponsiveImage
